import { render, staticRenderFns } from "./scoringDetail.vue?vue&type=template&id=a8a27050&scoped=true"
import script from "./scoringDetail.vue?vue&type=script&lang=js"
export * from "./scoringDetail.vue?vue&type=script&lang=js"
import style0 from "./scoringDetail.vue?vue&type=style&index=0&id=a8a27050&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a27050",
  null
  
)

export default component.exports